import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentAgreementPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsEnrollmentAgreementPage";

/**
 * @name CaptureMabiEDEStatementsEnrollmentEnrollmentAgreementDefault
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentEnrollmentAgreementDefault(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentAgreementPage />
}